import type { FC } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import { Box, Image, Stack, Text } from '@eneco/sparky';

import { CreditWarningBox, CreditWarningText } from './CreditWarningBar.css';

export const CreditWarningBar: FC = () => {
  return (
    <Box padding="4" backgroundColor="backgroundPrimary" className={CreditWarningBox}>
      <Stack direction="row" alignY="center" alignX="center">
        <Text align="center" size="BodyXL" className={CreditWarningText}>
          Let op! Geld lenen kost geld
          <Box as="span" paddingLeft="2">
            <Image
              src={`${getStaticPrefix()}/images/multilabel/afmcreditwarning/afm-beeldmerk.svg`}
              alt=""
              height="28px"
            />
          </Box>
        </Text>
      </Stack>
    </Box>
  );
};

export default CreditWarningBar;
